export default __webpack_public_path__ + "41080f22fadeee876358c253895ca257.otf";